import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import RootFractionInput, {
  parseRootFractionInput as parseRoot,
  formatLatexPreview,
} from "../../../../components/inputs/RootFractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

// sqrt(n)=k*sqrt(m) z maks. kwadratem wyciągniętym przed pierwiastek
function simplifySqrt(n) {
  if (n <= 0) return { k: 0, m: 0 };
  let k = 1, m = n;
  for (let p = 2; p * p <= m; p++) {
    while (m % (p * p) === 0) {
      k *= p; m /= (p * p);
    }
  }
  return { k, m };
}
const kSqrtMLatex = ({ k, m }) => (m === 1 ? `${k}` : (k === 1 ? `\\sqrt{${m}}` : `${k}\\sqrt{${m}}`));

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // 3..20
  const a = pick(A), b = pick(A);
  const S = a*a + b*b;                      // d^2
  const { k, m } = simplifySqrt(S);
  return {
    type: "RectangleDiagonalFromSidesTask",
    data: { a, b, S, k, m, dValue: Math.sqrt(S), dLatex: kSqrtMLatex({ k, m }) },
  };
}

export function renderTask({ data }) {
  const { a, b } = data;
  return (
    <div style={{ marginTop: 8 }}>
      Dany jest prostokąt o bokach <InlineMath math={`a=${a}`} /> i <InlineMath math={`b=${b}`} />.
      Oblicz długość jego przekątnej <InlineMath math={"d"} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <RootFractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="d"
      placeholder="np. 5√2, sqrt(50), 13"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseRoot(raw);
  return Number.isFinite(val) && Math.abs(val - data.dValue) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`d=${data.dLatex}`} />;

export function renderExplanation({ data }) {
  const { a, b, S, k, m } = data;
  let line = `d=\\sqrt{${a}^2+${b}^2}=\\sqrt{${S}}`;
  if (m === 1) line += `=${k}`;
  else if (k > 1) line += `=${k}\\,\\sqrt{${m}}`;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> W prostokącie z Pitagorasa: <InlineMath math={"d^2=a^2+b^2"} />.
      <BlockMath math={line} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, "d")} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
